import { BannerBottomHeader } from '@smuchile/pkg-unimarc-components/stories/organisms/HeaderPrototype/BottomBanner'
import {
  getCookie,
  isValidArrayWithData,
  useContentful,
  useMobile,
  useOrderForm,
  useSession
} from '@smuchile/pkg-unimarc-hooks'
import { useRouter } from 'next/router'
import { IHeaderBottomBanner } from 'shared/interfaces/HeaderBottomBanner'
import { headerBottomBannerQuery } from 'shared/queries'

export const BannerBottom = () => {
  const router = useRouter()
  const saleChannel = getCookie('co_sc')
  const { data: orderForm } = useOrderForm()
  const { isLoggedIn } = useSession()
  const { innerWidth } = useMobile()
  const isMobile = innerWidth < 1280

  const { data } = useContentful({
    id_contentful: 'headerBottomBanner',
    graphQL: {
      query: headerBottomBannerQuery
    }
  }) as IHeaderBottomBanner

  const banners = data?.data?.homeCollection?.items?.[0]?.headerBannerApp
  const hasReference = banners?.referenceType === 'url' && banners?.reference
  const bannerSaleChannels = banners?.saleChannels

  const imageUrl = isMobile
    ? banners?.imageMobile?.url
    : banners?.imageDesktop?.url

  const handleClick = () => {
    if (hasReference) router.push(banners?.reference)
  }

  if (!banners) return null

  const shouldShowBanner = (): boolean => {
    const hasSalesChannel = Boolean(saleChannel)
    const isSegmented = isValidArrayWithData(bannerSaleChannels)
    const matchSalesChannel =
      !!saleChannel && bannerSaleChannels?.includes(saleChannel)

    // Case without segmentation → always show
    if (!isSegmented) return true

    // Case logged without address -> hide
    if (isLoggedIn && !orderForm?.data?.selectedAddresses) return false

    // Case with segmentation and address
    if (hasSalesChannel) return matchSalesChannel

    // Case with segmentation and no address
    // Guest without address and segmented includes 39 → show
    if (!isLoggedIn && bannerSaleChannels?.includes('39')) return true

    return false
  }

  if (!shouldShowBanner()) return null

  return (
    <BannerBottomHeader
      imageUrl={imageUrl}
      isMobile={isMobile}
      onClick={handleClick}
    />
  )
}
